<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
export default {
  components: { FontAwesomeIcon },
  props: {
    file: {
      type: Object,
      required: true,
    },
    btnClass: {
      type: String,
      default: 'mr-4',
    },
    customStyle: {
      type: String,
      default: '',
    },
    fileName: {
      type: String,
      default: null,
    },
    removable: {
      type: Boolean,
      default: true,
    },
    hideText: {
      type: Boolean,
      default: false,
    },
    smallText: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    download() {
      this.$wait.start('downloading');
      this.$http.get(`files/${this.file.id}`, { responseType: 'arraybuffer' }).then((response) => {
        this.$wait.end('downloading');
        const headers = response.headers;
        const blob = new Blob([response.data], { type: headers['content-type'] });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = this.file.name;
        link.click();
      });
    },
  },
};
</script>

<template>
  <div v-if="file" class="d-flex align-items-center no-wrap">
    <b-link :disabled="$wait.is('downloading')" :class="btnClass" :style="customStyle" @click="download">
      <template v-if="$wait.is('downloading')">
        <FontAwesomeIcon icon="spinner" spin />
      </template>
      <template v-else>
        <slot></slot>
      <template v-if="hideText"></template>
      <template v-else-if="smallText">
        <small>&nbsp;{{ fileName || file.name }}</small>
      </template>
      <template v-else>
        {{ fileName || file.name }}
      </template>
      </template>
    </b-link>
    <b-link v-if="removable" :disabled="disabled" class="text-secondary" @click="$emit('remove', file)">&times;</b-link>
  </div>
</template>
